const getPatientSSN = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['Social Security Number'];
};

export default getPatientSSN;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientSSN.js